import { render, staticRenderFns } from "./PreferencePurchase.vue?vue&type=template&id=ff278660&"
import script from "./PreferencePurchase.vue?vue&type=script&lang=ts&"
export * from "./PreferencePurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff278660')) {
      api.createRecord('ff278660', component.options)
    } else {
      api.reload('ff278660', component.options)
    }
    module.hot.accept("./PreferencePurchase.vue?vue&type=template&id=ff278660&", function () {
      api.rerender('ff278660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferencePurchase.vue"
export default component.exports